module.exports = __webpack_public_path__ + "img/menu.a1c381d8.svg";